import * as React from 'react';
import { useField } from 'formik';
import styles from '../forms.module.css';

interface CheckboxProps {
    id: string;
    name: string;
    display: string;
    required?: boolean;
    hideError?: boolean;
}

export const CheckBox: React.FC<CheckboxProps> = ({ children, id, required = false, display, hideError, ...props }) => {
    const [field, meta] = useField(props as any);
    return (
        <>
            <label className={styles.CheckBox}>
                <input type="checkbox" checked={field.value || false} {...field} data-qa={`form-input-checkbox-${id}`} />
                <span>{display}</span>
            </label>
            {!hideError && meta.touched && meta.error && (
                <div className={styles.Error}>
                    <span>{meta.error}</span>
                </div>
            )}
        </>
    );
};
